var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.604 8.294a1 1 0 00-1.41 0l-13.74 13.71-13.74-13.71a1.004 1.004 0 00-1.42 1.42l14.34 14.29a1 1 0 00.71.3h.22a1 1 0 00.7-.3l14.34-14.29a1 1 0 000-1.42z"
  })));
}

export default SvgOpen;